import { defineStore } from 'pinia'
import type { ICompany, TCompanyModalType } from '~/shared/interfaces/account'

interface ICompaniesState {
  companies: ICompany[]
  showCRUDCompanyModal: boolean
  currentModalType: TCompanyModalType
  editingCompany: ICompany | null
  isUserHasCompanies: boolean | null
}

const useCompaniesStore = defineStore('companies', {
  state: (): ICompaniesState => ({
    companies: [],
    showCRUDCompanyModal: false,
    currentModalType: 'create',
    editingCompany: null,
    isUserHasCompanies: null
  }),
  getters: {
    getMainCompany(state) {
      return state.companies.length > 0 ? state.companies.find(({ isMain }) => isMain) || state.companies[0] : null;
    },
  },
  actions: {
    setCompaniesList(companies: ICompany[]) {
      this.companies = companies;
      if (companies.length) {
        this.isUserHasCompanies = true
      }
    },
    setMainCompany(companyId: number) {
      this.companies.forEach(company => {
        company.isMain = company.id == companyId;
      })
    },
    deleteCompanyFromList(companyId: number) {
      this.companies = this.companies.filter(company => company.id != companyId);
    },
    setCRUDCompanyModalVisibility(state: boolean, type?: TCompanyModalType, editingCompany?: ICompany) {
      this.editingCompany = editingCompany || null;
      this.currentModalType = type || this.currentModalType;
      this.showCRUDCompanyModal = state;
    },
    setEditingCompany(company?: ICompany) {
      this.editingCompany = company || null;
    }
  }
})

export default useCompaniesStore;
